export interface ReturnDocument {
  information: string
  url: string
  lineItemId?: string
  returnReasonKey?: string
}

export const documentsForLineItem = (
  documents: ReturnDocument[],
  lineItemId: string
): ReturnDocument[] =>
  documents.filter((document) => document.lineItemId === lineItemId)

export const documentsWithoutLineItem = (
  documents: ReturnDocument[],
  lineItemIds: string[]
): ReturnDocument[] =>
  documents.filter(
    (document) =>
      !document.lineItemId || !lineItemIds.includes(document.lineItemId)
  )
